import { useMemo } from 'react';
import { MenuNavigationShellPage } from '@/app/layout/MenuNavigationShellPage';
import type { AgendaRegistration } from '@/app/layout/MenuNavigationShellPage';
import { PRODUCTS_STATION_CHAINS } from './permissions';
import { stationChainListAgenda } from './stations/chains/list/stationChainListAgenda';
import { StationChainListPage } from './stations/chains/list/stationChainListPage';
import { stationChainDetailAgenda } from './stations/chains/detail/stationChainDetailAgenda';
import { StationChainDetailPage } from './stations/chains/detail/StationChainDetailPage';

/** Slice agendy Trasy autobusů (route `/products-chains`) — listpage tras jako root, detail jako overlay. */
export function ProductsChainsSlicePage() {
  const agendas: AgendaRegistration[] = useMemo(
    () => [
      {
        agenda: stationChainListAgenda,
        component: StationChainListPage,
        permission: PRODUCTS_STATION_CHAINS,
      },
      {
        agenda: stationChainDetailAgenda,
        component: StationChainDetailPage,
        permission: PRODUCTS_STATION_CHAINS,
      },
    ],
    []
  );

  return <MenuNavigationShellPage agendas={agendas} rootAgenda={stationChainListAgenda} />;
}
